import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import { CustomModal } from 'commons-ui';
import AuthorizedRoute from '../../../../permission/AuthorizedRoute';
import { PAGE_NAMES, RESOURCES, SETTINGS_V2_ACTION } from '../../../../settingsV2Constant';

import CreatePermissionsSet from './submodules/create';
import EditPermissionsSet from './submodules/edit';
import ListPermissionsSet from './submodules/list';

const PermissionsDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<AuthorizedRoute
				configPageName={PAGE_NAMES.permissionsManagement}
				configResourceName={RESOURCES.permissionSet}
				configActionName={SETTINGS_V2_ACTION.getPermissionSets}
				path={`${path}/list`}
				component={ListPermissionsSet}
				exact
			/>
			<AuthorizedRoute
				configPageName={PAGE_NAMES.permissionsManagement}
				configResourceName={RESOURCES.permissionSet}
				configActionName={SETTINGS_V2_ACTION.createPermissionSet}
				path={`${path}/create`}
				component={CreatePermissionsSet}
				exact
			/>
			<AuthorizedRoute
				configPageName={PAGE_NAMES.permissionsManagement}
				configResourceName={RESOURCES.permissionSet}
				configActionName={SETTINGS_V2_ACTION.editPermissionSet}
				exact
				path={`${path}/edit`}
				component={EditPermissionsSet}
			/>
			<Redirect to={`${path}/list`} />
			<CustomModal />
		</Switch>
	);
};

export default PermissionsDashboard;
